<template>
  <div class="sticky inset-x-0 top-0 h-0">
    <DefaultGrid
      class="pt-10 transition-transform duration-300"
      :class="show || uiStore.showMenu ? '' : '-translate-y-full'"
    >
      <div class="col-span-full flex items-center">
        <div class="flex flex-1 justify-start">
          <Menu :bordered="scrolled" />
        </div>
        <div class="flex shrink justify-center">
          <div>
            <NuxtLink
              v-if="!uiStore.mountedSchool"
              to="/"
              @click="uiStore.showMenu = false"
            >
              <SvgLogo class="h-16 w-auto text-white md:h-18" />
            </NuxtLink>
          </div>
        </div>
        <div class="flex flex-1 justify-end gap-x-2.5">
          <div class="hidden xl:block">
            <NuxtLink
              to="/get-involved"
              class="btn btn-sm h-10 gap-x-2.5 border-2 bg-white text-[16px] hover:bg-white md:h-13"
              :class="scrolled ? 'border-black/10' : 'border-transparent'"
            >
              <SvgGlyphSupport />
              <span>Get involved</span>
            </NuxtLink>
          </div>
          <div class="block">
            <ClientOnly>
              <PledgeLink
                location="nav"
                class="btn btn-sm h-10 gap-x-2.5 border-2 text-[16px] md:h-13"
                :class="[
                  uiStore.mountedSchool ? buttonClass : 'btn-yellow',
                  scrolled ? 'border-black/10' : 'border-transparent',
                ]"
              >
                <SvgGlyphPencil />
                <span class="lg:hidden">Join</span>
                <span class="hidden lg:inline">Join the movement</span>
              </PledgeLink>
            </ClientOnly>
          </div>
        </div>
      </div>
    </DefaultGrid>
  </div>
</template>

<script setup lang="ts">
const uiStore = useUIStore()

const show = ref(true)
const lastScrollY = ref(0)

const { y: scrollY } = useWindowScroll()

const scrolled = computed(() => scrollY.value > 20)

onMounted(() => {
  lastScrollY.value = scrollY.value
})

watch(scrollY, (newValue) => {
  const clampedScrollY = Math.max(0, newValue)
  const deltaScrollY = clampedScrollY - lastScrollY.value

  if (show.value) {
    show.value = !(deltaScrollY > 20)
  } else {
    show.value = deltaScrollY < -20 || newValue <= 0
  }

  lastScrollY.value = clampedScrollY
})

const buttonClass = ref('btn-black')

watch(
  () => uiStore.mountedSchool,
  (newValue) => {
    if (!newValue) return

    buttonClass.value = getContrastingColour(
      newValue?.themeColour || '#000000',
      'btn-black',
      'btn-white',
    )
  },
  {
    immediate: true,
  },
)
</script>
